// src/tours/whatsNew.js — the "What's new" lines for a viewer, from
// whatsNew.json (generated from the release notes by
// scripts/release_notes_json.py). Shown once per user per version
// (UserTourState key "whatsnew@<version>").
import data from '../whatsNew.json';

const AUDIENCE = { tenant: 'tenant', owner: 'landlord', manager: 'landlord', superadmin: 'platform' };

// A line with `flag: "property_modules"` shows only while the modules are
// available to the viewer (/accounts/me/ `modules_available`); unknown = off.
export function whatsNewFor(role, { modulesAvailable = false } = {}) {
  const mine = AUDIENCE[role];
  if (!mine) return [];
  return data.items.filter((i) => (i.audience === mine || i.audience === 'all')
    && (!i.flag || (i.flag === 'property_modules' && modulesAvailable === true)));
}

export const whatsNewKey = () => `whatsnew@${data.version}`;
export const whatsNewVersion = data.version;
